import React from "react";
import { priceUnitLabel, stockUnitLabel } from "../../pos/logic/saleUnits";

function money(value) {
  return new Intl.NumberFormat("es-CL", { style: "currency", currency: "CLP", maximumFractionDigits: 0 }).format(Number(value || 0));
}

function stockStatus(quantity, shortage, saleUnit) {
  const qty = Number(quantity || 0);
  const shortageQty = Number(shortage || 0);
  if (shortageQty > 0) return {
    key: "shortage",
    label: `Vendidos sin stock: ${shortageQty.toLocaleString("es-CL")} ${stockUnitLabel(saleUnit)}`,
  };
  if (qty <= 0) return { key: "out", label: "Sin stock" };
  if (qty <= 5) return { key: "low", label: "Stock bajo" };
  return { key: "ok", label: "Disponible" };
}

function ProductItem({ product, availableLocations, onEdit, onAdjust, onArchive }) {
  const status = stockStatus(product.qty, product.stock_shortage_qty, product.sale_unit);
  return (
    <article className={`inventory-product-row${status.key === "shortage" ? " has-shortage" : ""}`}>
      <button type="button" className="inventory-product-row__main" onClick={() => onEdit(product)} aria-label={`Editar ${product.description || product.code}`}>
        <span className="inventory-product-row__identity">
          <span className="inventory-product-row__avatar" aria-hidden="true">{String(product.brand || product.description || "P").charAt(0).toUpperCase()}</span>
          <span><strong>{product.description || [product.brand, product.model, product.flavor].filter(Boolean).join(" ") || "Producto sin nombre"}</strong><small><span className="material-symbols-outlined">barcode</span>{String(product.code || "Sin código")} · {product.location_name || availableLocations?.[product.location] || `Ubicación ${product.location}`}</small></span>
        </span>
        <span className="inventory-product-row__category"><strong>{product.category || "Sin categoría"}</strong><small>{product.subcategory || "Sin subcategoría"}</small></span>
        <span className="inventory-product-row__stock"><strong>{Number(product.qty || 0).toLocaleString("es-CL")} {stockUnitLabel(product.sale_unit)}</strong><small className={`inventory-stock-chip is-${status.key}`}>{status.label}</small></span>
        <span className="inventory-product-row__money"><strong>{money(product.unit_price)} {priceUnitLabel(product.sale_unit)}</strong><small>Costo {money(product.unit_cost)} {priceUnitLabel(product.sale_unit)}</small></span>
        <span className="inventory-product-row__margin"><strong>{Number(product.margin || 0).toLocaleString("es-CL")}%</strong><small>Margen</small></span>
        <span className="material-symbols-outlined inventory-product-row__chevron" aria-hidden="true">chevron_right</span>
      </button>
      <div className="inventory-product-row__actions">
        <button type="button" className="inventory-icon-button" onClick={() => onAdjust(product)} aria-label={`Ajustar stock de ${product.description || product.code}`} title="Ajustar stock"><span className="material-symbols-outlined">inventory</span></button>
        <button type="button" className="inventory-icon-button" onClick={() => onEdit(product, "barcode")} aria-label={`Imprimir etiqueta de ${product.description || product.code}`} title="Código y etiquetas"><span className="material-symbols-outlined">barcode_scanner</span></button>
        <button type="button" className="inventory-icon-button is-danger" onClick={() => onArchive(product)} aria-label={`Archivar ${product.description || product.code}`} title="Archivar producto"><span className="material-symbols-outlined">archive</span></button>
      </div>
    </article>
  );
}

export default ProductItem;
